import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import config from '@iotv/config';
import { pluralReadableTypeName } from '@iotv/core-services';
import { classDerivedDeviceEnabledTypes, getChildEdgeTypeId } from '@iotv/datamodel';
import { ExpressionFunctionType, UNCLASSIFIED_DOMAIN } from '@iotv/iotv-v3-types';
import { TreeItem2 as TreeItem } from '@mui/x-tree-view';
import { useContext } from 'react';
import { AlertErrors } from '../../../../ErrorHandling/ErrorBoundaryFallback';
import { AdjacentType, ComparisonType, LogicalOperatorType } from '../../../../types/AppTypes';
import { DefaultStepTypeFolderClickWrapper } from '../../../../v2/components/generic/ObjectTree';
import { ObjectTree } from '../../../../v2/components/generic/ObjectTree/ObjectTreev2';
import { NavigationSkeleton } from '../../../common/NavigationSkeleton';
import { getSingleTypeRecursivePath } from '../../../EnititySupport/RecusiveEntityGroup/getRecursiveQueryPath';
import { handleContextMenu } from '../../clickWrappers/helpers';
import { RoutingLabelClickWrapper } from '../../clickWrappers/RoutingLabelClickWrapper';
import { NavigationContext } from '../../NavigationContext';
const debug = process.env.REACT_APP_DEBUG && false;
const GROUPER_TYPE = 'Group';
/** @deprecated */
export const entityGroups = [...classDerivedDeviceEnabledTypes, ...Object.keys(config.app.webUI.groupedObjectTypes ?? {})].reduce((det, got) => {
    if (!det.includes(got))
        det.push(got);
    return det;
}, []);
/** @deprecated */
export const getContainedTypeLabelWrapper = (entityTypeId) => (props) => (_jsx(DefaultStepTypeFolderClickWrapper, { ...props, element: _jsx(_Fragment, { children: "Entity Groups" }), support: entityTypeId }));
/** @deprecated */
export const AdminEntityTrees = ({ applicationData, contextCustomer, transactionFunctions }) => {
    if (contextCustomer)
        applicationData.loadItems([contextCustomer]);
    return entityGroups
        .sort()
        .map((entityTypeId) => EntityGroupTree({ entityTypeId, nodeEdgeMapper: applicationData, contextObject: contextCustomer, transactionFunctions }));
};
/** Finds groups directly under a context object and iteratively queries down for subgroups and entities in those groups */
export const EntityGroupTree = ({ entityTypeId, nodeEdgeMapper, contextObject, transactionFunctions, name, uniqueTreeId, domain }) => {
    const navigationContext = useContext(NavigationContext);
    const nodeFilters = [
        { setOperation: LogicalOperatorType.AND, filters: [{ key: 'supportedType', predicate: ComparisonType.EQUALS, value: entityTypeId }] },
    ];
    if (domain === UNCLASSIFIED_DOMAIN)
        nodeFilters.push({ setOperation: LogicalOperatorType.AND, filters: [{ key: 'domain', predicate: ExpressionFunctionType.NOT_EXISTS }] });
    return (_jsx(TreeItem, { itemId: `${name}-${uniqueTreeId}-${entityTypeId}-group`,
        // Bit of a hack, I know. We need a better mechanism for providing a context object to the navigation context rather than assuming it's context customer
        label: contextObject.type === 'Customer'
            ? handleContextMenu(name ?? pluralReadableTypeName(entityTypeId), entityTypeId, navigationContext, undefined, domain !== UNCLASSIFIED_DOMAIN ? domain : undefined)
            : (name ?? pluralReadableTypeName(entityTypeId)),
        children: (_jsx(ObjectTree, { uniqueTreeId,
            nodeEdgeMapper,
            queryPaths: [
                {
                    stepQuery: {
                        objectTypeId: GROUPER_TYPE,
                        adjacencyType: AdjacentType.CHILD,
                        edgeTypeId: getChildEdgeTypeId(contextObject.type, GROUPER_TYPE),
                        nodeFilters,
                    },
                    thisStepTypeFolderClickWrapper: undefined,
                    renderTypeFolder: false,
                    nextSteps: getSingleTypeRecursivePath({
                        groupObjectType: GROUPER_TYPE,
                        containedObjectType: entityTypeId,
                        ContainedTypeLabelWrapper: getContainedTypeLabelWrapper(entityTypeId),
                        ContainedTypeInstanceClickWrapper: RoutingLabelClickWrapper,
                    }),
                },
            ],
            contextObjects: [contextObject],
            transactionFunctions,
            onTypeFolderClickWrapper: undefined /*CustFolderClickWrapper*/,
            hideTopStep: true,
            maintree_rightclick: true }, entityTypeId)) }, `${name}-${uniqueTreeId}-${entityTypeId}-group`));
};
export const SpecificEntityGroupTree = (entityTypeId, uniqueTreeId, name, domain) => {
    return ({ applicationData, contextCustomer, transactionFunctions }) => {
        const key = `${entityTypeId}_${name}_${uniqueTreeId}_${domain}`;
        return (_jsx(AlertErrors, { children: contextCustomer ? (_jsx(EntityGroupTree, { contextObject: contextCustomer, entityTypeId, nodeEdgeMapper: applicationData, transactionFunctions, name, uniqueTreeId, domain }, key)) : (_jsx(NavigationSkeleton, {}, key)) }, key + '_errors'));
    };
};
